<template>
	<v-card>
		<v-card-title>
        	<span class="headline">{{ title }}</span>
      	</v-card-title>
      	<v-card-text>
        	<v-container>
        		<el-form ref="form" :model="formData" label-width="100px" :rules="rules">
        			<el-form-item :label="roleNameLabel" prop="name">
						<el-input v-model.sync="formData.name" :placeholder="nameTips"><!-- 请输入角色名称 --></el-input>
					</el-form-item>
					<el-form-item :label="roleCodeLabel" prop="code">
						<el-input v-model.sync="formData.code" :placeholder="codeTips"><!-- 请输入角色编码 --></el-input>
					</el-form-item>
				</el-form>
			</v-container>
		</v-card-text>
		<v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error"  @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}</v-btn>
        <v-btn color="success"  @click="saveRole">{{ $vuetify.lang.t('$vuetify.custom.preservation') }}</v-btn>
      </v-card-actions>
	</v-card>
</template>
<script>
	import {Input} from '@/plugins/element'
	import {Form} from '@/plugins/element'
	import {FormItem} from '@/plugins/element'
	export default{
		model:{
			prop:'dialog',
			event:'changeShowDetail'
		},
		data(){
			return{
				formData:{
					id:'',
					name:'',
					code:'',
				},
				roleNameLabel:this.$vuetify.lang.t('$vuetify.custom.role.role') + this.$vuetify.lang.t('$vuetify.custom.role.name') + ':',
				roleCodeLabel:this.$vuetify.lang.t('$vuetify.custom.role.role') + this.$vuetify.lang.t('$vuetify.custom.role.code') + ':',
				nameTips:this.$vuetify.lang.t('$vuetify.custom.role.pleaseEnterTheRoleName'),
				codeTips:this.$vuetify.lang.t('$vuetify.custom.role.pleaseEnterRoleCode'),
				rules:{
					name: [
			            { required: true, message: '请输入角色名称', trigger: 'blur' },
			            { max: 64, message: '长度不能超过64个字符', trigger: 'blur' }
			        ],
			        code: [
			            { required: true, message: '请输入角色编码', trigger: 'blur' },
			            { max: 64, message: '长度不能超过64个字符', trigger: 'blur' }
			        ],
				}
			}
		},
		props:{
			dialog:{
				type:Boolean
			},
			title:{
				type:String,
				default:''
			},
			addOrUpdate:{
				type:Boolean,
				default:true
			},
			roleId:{
				type:String
			}
		},
		watch:{
			'dialog'(val){
				if(val){
					if(!this.addOrUpdate){
						this.getRoleInfo();
					}else{
						this.formData.id = "";
						this.formData.name = "";
						this.formData.code = "";
					}
				}
			}
		},
		created(){
			console.info('created',this.addOrUpdate);
			if(!this.addOrUpdate){
				this.getRoleInfo();
			}
	    },
		methods:{
			getRoleInfo(){
				console.info('getRoleInfo',this.roleId);
				this.$api.sysRole.getRoleById(this.roleId).then(data =>{
					if(data.flag){
						// console.info('data.obj',data.obj);
						this.formData.id = data.obj.id;
						this.formData.name = data.obj.name;
						this.formData.code = data.obj.code;
						console.info('getRoleInfo',this.formData);
					}
				})
			},
			hiddenDialog(){
				this.$emit('changeShowDetail',false);
				this.$emit('initialize')
				
			},
			saveRole(){
				this.$refs.form.validate((valid)=>{
					if(valid){
						if(this.addOrUpdate){
							this.$api.sysRole.addRole(this.formData).then(data =>{
								if(data.flag){
									this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.preservation') + this.$vuetify.lang.t('$vuetify.custom.success'));
									 this.$emit('initialize')
								}else{
					              this.$dialog.alert(data.msg)
					            }
							});
						}else{
							this.$api.sysRole.updateRole(this.formData).then(data =>{
								if(data.flag){
									this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.preservation') + this.$vuetify.lang.t('$vuetify.custom.success'));
									 this.$emit('initialize')
								}else{
					              this.$dialog.alert(data.msg)
					            }
							});
						}
					}else{
						return
					}
				});
			   
				this.$emit('changeShowDetail',false);

			}
		},
		components:{
			Input,
			Form,
			FormItem
		}
	}
</script>